import {getSegments, getSegmentsByGroupId} from '@/services/segments'
import {keepPreviousData, useQuery} from '@tanstack/react-query'

export const useSegmentsByGroupId = (groupId = '') => {
  const query = useQuery({
    queryKey: ['SEGMENTS_BY_GROUP', groupId],
    queryFn: () => getSegmentsByGroupId(groupId),
    enabled: !!groupId, // Only fetch when groupId is provided
  })

  return query
}

export const useSegments = (page = 0, pageSize = 10, search = '') => {
  const query = useQuery({
    queryKey: ['SEGMENTS', page, pageSize, search],
    queryFn: () => getSegments(page, pageSize, search),
    placeholderData: keepPreviousData,
  })

  return query
}
